import React from "react";
import "./HimalyanDiamond.css"; // Import your CSS for styling
import prodImg from "../../assets/PackageImages/HimalyaDiamond.png";
import { projects } from "../../data/projectsData";
import {
  Container,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { Link, useParams } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useMediaQuery, useTheme } from "@mui/material";
import NutritionalTable from "./NutritionalTable"

const HimalyanDiamond = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const otherProducts = Object.values(projects).flatMap((group, index) =>
    group.map((item) => {
      return { ...item, group: `${index + 1}` };
    })
  );

  const tableData = [
    {
      nutrient: "Protein",
      value: "24%",
      comment:
        "Supports consistent milk production and maintains muscle health.",
    },
    {
      nutrient: "Fat",
      value: "3.5 - 4%",
      comment: "Provides a balanced energy source for lactating cows.",
    },
    {
      nutrient: "Fiber",
      value: "10%",
      comment: "Improves digestion and supports gut health.",
    },
    {
      nutrient: "Moisture",
      value: "10 - 11%",
      comment: "Maintains feed freshness and enhances palatability.",
    },
    {
      nutrient: "Insoluble Matter",
      value: "Max 2%",
      comment: "Ensures feed purity and digestibility.",
    },
  ];

  return (
    <div className="product-container">
      <div className="product-details">
        <div
          className={
            isMobile ? "product-image product-image--mobile" : "product-image"
          }
        >
          <img
            src={prodImg} // Replace with the actual image path
            alt="Himalaya Diamond Premium"
          />
        </div>
        <div className="product-info">
          <div>
            <div className="product-title">
              HIMALAYA DIAMOND{" "}
              <span
                style={{
                  fontFamily: "Playfair Display",
                  fontStyle: "italic",
                  color: "#ffc40c",
                  fontWeight: "bold",
                  fontSize: "1.5rem",
                }}
              >
                (Premium)
              </span>
            </div>

            <div
              style={{
                textAlign: "justify",
              }}
            >
              <p>
                Introducing Himalaya Diamond (TYPE 1), a premium cattle feed
                formulated with a unique blend of ingredients to optimize your
                herd's health and productivity. Designed in 8mm pellet form for
                easy consumption, Himalaya Diamond is packed with essential
                nutrients to support robust growth and peak performance.
              </p>
              <p>
                This premium feed blend is formulated from a rich combination of
                rice bran, soybean, mustard de-oiled cakes, grains, molasses,
                bypass fat, and bypass protein. Himalya Diamond isn’t just
                feed—it’s a comprehensive nutritional solution designed to
                optimize cattle health, performance, and productivity, ensuring
                a healthy, thriving herd.
              </p>
            </div>
          </div>
          <div>
            <h3 className="benefits-title">KEY BENEFITS:</h3>
            <div className="benefits">
              <ul>
                <li className="benefit">
                  <div>
                    <b>Enhanced Digestion:</b> Our proprietary blend
                    incorporates buffer and live yeast, creating a favorable
                    environment for digestion and nutrient absorption.
                  </div>
                </li>
                <li className="benefit">
                  <div>
                    <b>Balanced Nutrition:</b> Himalaya Diamond provides a
                    harmonious balance of protein, fat, fiber, and essential
                    minerals to meet your cattle's specific nutritional needs.
                  </div>
                </li>
                <li className="benefit">
                  <div>
                    <b>Optimal pH Maintenance:</b> The inclusion of buffers
                    helps regulate rumen pH, ensuring optimal digestion and
                    preventing acidosis.
                  </div>
                </li>
                <li className="benefit">
                  <div
                    className="bold-key"
                    style={{
                      fontWeight: "bold",
                    }}
                  ></div>
                  <div>
                    <b>Improved Rumen Health:</b> The live yeast component
                    promotes a healthy rumen microbiome, supporting efficient
                    digestion and nutrient utilization.
                  </div>
                </li>
                <li className="benefit">
                  <div>
                    <b>Increased Milk Yield:</b> The balanced protein content,
                    particularly from high-quality sources like soybean and
                    mustard de-oiled cakes, directly contributes to higher milk
                    production, while bypass protein ensures that essential
                    amino acids are absorbed where they're most needed.
                  </div>
                </li>
                <li className="benefit">
                  <div>
                    <b>Stronger Immune System:</b> The balanced nutrient profile
                    supports a healthy immune response, helping your cattle
                    resist diseases and infections.
                  </div>
                </li>
                <li className="benefit">
                  <div>
                    <b>Improved Milk Quality:</b> Enhances the quality of milk
                    produced, such as fat content and protein levels.
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div>
            <NutritionalTable isCommentPresent={false} data={tableData} />
          </div>
        </div>
      </div>

      <div className="other-products">
        <Typography variant="h6" gutterBottom>
          Products Catalogue
        </Typography>
        <List>
          {otherProducts.map((product) => {
            return (
              <ListItem
                key={product.id}
                component={Link}
                to={`/products/${product.id}`}
                style={{
                  borderBottom: "1px lightgray dotted",
                  color: "black",
                  ...(product.id === "Himalya-diamond-pellets" && {
                    backgroundColor: "#4caf50",
                    color: "white",
                    borderRadius: "1rem",
                  }),
                }}
              >
                <ListItemIcon
                  style={{
                    minWidth: "0px",
                  }}
                >
                  <ArrowForwardIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                  primary={product.title}
                />
              </ListItem>
            );
          })}
        </List>
      </div>
    </div>
  );
};

export default HimalyanDiamond;
